import React from "react";
import styles from "./SimpleLink.module.sass";
import { Link } from "react-router-dom";
const SimpleLink = props => {
  const {
    label,
    to,
    className
  } = props;
  return /*#__PURE__*/React.createElement(Link, {
    className: `${styles["link"]} ${className || ""}`,
    to: to
  }, label);
};
export default SimpleLink;